"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchCustomerPaymentMethod = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const ErrorResolver_1 = require("../../../../contexts/ErrorResolver");
const useRequiredContext_1 = require("../../../../hooks/useRequiredContext");
const useClient_1 = require("../../../../hooks/useClient");
const useFetchCustomerPaymentMethod = (retailCustomerId, // RetailCustomer.id
gatewayId, // RetailLocation.paymentGatewayId
errorApproach = "modal") => {
    const client = (0, useClient_1.useClient)();
    const { resolveError } = (0, useRequiredContext_1.useRequiredContext)(ErrorResolver_1.ErrorResolverContext);
    const [paymentMethod, setPaymentMethod] = (0, react_1.useState)(null);
    const { error, isLoading, refetch } = (0, react_query_1.useQuery)(["retrievePaymentMethod", retailCustomerId, gatewayId], () => {
        if (!retailCustomerId)
            return;
        return gatewayId
            ? client.retailCustomers.retrievePaymentMethodByGatewayId(retailCustomerId, gatewayId)
            : client.retailCustomers.retrieveDefaultPaymentMethod(retailCustomerId);
    }, {
        retry: 0,
        enabled: false,
        onSuccess: (data) => {
            setPaymentMethod(data);
        },
        onError: (error) => {
            console.error(error);
            resolveError({
                title: "Unable to fetch customer payment method",
                approach: errorApproach,
                retry: refetch
            });
        }
    });
    return (0, react_1.useMemo)(() => ({
        paymentMethod,
        isLoading,
        error,
        refetch
    }), [paymentMethod, isLoading, error, refetch]);
};
exports.useFetchCustomerPaymentMethod = useFetchCustomerPaymentMethod;
//# sourceMappingURL=useFetchCustomerPaymentMethod.js.map